import { render, staticRenderFns } from "./underconstruction.vue?vue&type=template&id=93c9e6b0&scoped=true"
import script from "./underconstruction.vue?vue&type=script&lang=js"
export * from "./underconstruction.vue?vue&type=script&lang=js"
import style0 from "./underconstruction.vue?vue&type=style&index=0&id=93c9e6b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93c9e6b0",
  null
  
)

export default component.exports